import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class SofiService {
    private readonly config: { headers: { "Content-Type": string } };

    constructor(private httpClient: HttpClient) {
        this.config = {
            headers: {
                'Content-Type': 'application/json;'
            }
        }

    }

    sendToElvis(sofi): Observable<any> {
        return this.httpClient.post('api/elvis', sofi, this.config);
    }
}
